import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, FormControlLabel, makeStyles } from '@material-ui/core'
import SydModal from '../../commonDesign/SydModal'
import SydModalActions from '../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../commonDesign/Button'
import { useSaveExplorerConfiguration } from '../../../api/coreData'

const useStyles = makeStyles(() => ({
  field: {
    marginBottom: 16
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: 14,
    border: 'var(--border-neutral-thin, 1px solid #ddd)',
    borderRadius: 'var(--border-radius-sm, 4px)',
    background: 'var(--theme-color-surface-d0, #fff)',
    color: 'inherit',
    outline: 'none',
    '&:focus': {
      borderColor: 'var(--color-primary-500, #1976d2)',
      outline: '1px solid var(--color-primary-500, #1976d2)'
    }
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: 'var(--color-neutral-600, #666)',
    marginBottom: 6,
    display: 'block'
  }
}))

export default function SaveViewDialog ({ open, onClose, serializeConfig, onSaveComplete }) {
  const classes = useStyles()
  const [name, setName] = useState('')
  const [isDefault, setIsDefault] = useState(false)
  const saveMutation = useSaveExplorerConfiguration()

  useEffect(() => {
    if (open) {
      setName('')
      setIsDefault(false)
    }
  }, [open])

  const handleSave = useCallback(() => {
    const trimmed = name.trim()
    if (!trimmed || saveMutation.isLoading) return

    const serialized = serializeConfig()
    saveMutation.mutate({
      name: trimmed,
      ...serialized,
      isDefault
    }, {
      onSuccess: (data) => {
        onSaveComplete({ explorerConfigurationId: data.explorerConfigurationId, name: trimmed })
        onClose()
      }
    })
  }, [name, isDefault, saveMutation, serializeConfig, onSaveComplete, onClose])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') handleSave()
  }, [handleSave])

  return (
    <SydModal open={open} onClose={onClose} title='Save View As' size='xsmall'>
      <div className={classes.field}>
        <label className={classes.label}>View Name</label>
        <input
          className={classes.input}
          type='text'
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='My Portfolio View'
        />
      </div>
      <FormControlLabel
        control={
          <Checkbox
            checked={isDefault}
            onChange={(e) => setIsDefault(e.target.checked)}
            size='small'
            color='primary'
          />
        }
        label='Set as default view'
      />
      <SydModalActions>
        <SydButton variant='outline' size='sm' onClick={onClose} disabled={saveMutation.isLoading}>Cancel</SydButton>
        <SydButton
          variant='primary'
          size='sm'
          onClick={handleSave}
          disabled={!name.trim() || saveMutation.isLoading}
          processing={saveMutation.isLoading}
        >
          Save
        </SydButton>
      </SydModalActions>
    </SydModal>
  )
}

SaveViewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  serializeConfig: PropTypes.func.isRequired,
  onSaveComplete: PropTypes.func.isRequired
}
